module.exports = __webpack_public_path__ + "img/1556150570.18ccd09d.jpg";